var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuobiDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42784 0.00607846C5.17319 0.567562 6.15183 2.29748 6.15183 4.30617C6.15183 5.30807 5.41021 6.27375 4.63699 7.28057C3.73488 8.45522 2.78977 9.68587 2.92923 11.0954C3.03211 12.1502 3.47217 12.9352 3.74425 13.4205C4.03162 13.9331 4.13162 14.1115 3.4492 13.9206C1.06487 13.2583 -1.27201 9.67387 1.2428 6.40383C1.47332 6.10428 1.74386 5.82101 2.02773 5.52379C3.08535 4.41642 4.32811 3.11521 4.37643 0.0555048C4.3705 -0.0255544 4.42784 0.00607846 4.42784 0.00607846ZM7.2433 5.63668C7.25713 5.61098 7.27888 5.61889 7.2947 5.62878C7.78896 6.05187 9.17685 7.50895 8.98112 9.82211C8.8625 11.2575 8.06377 12.5504 6.83207 13.2978C6.14203 13.6442 6.12137 13.9849 6.04128 13.9995C6.00571 14.0059 5.95843 13.9481 5.83563 13.798C5.14762 12.9538 3.9258 11.384 6.0709 8.12975C6.70356 7.1689 7.20178 6.12502 7.2433 5.63668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobiDark);
export default __webpack_public_path__ + "static/media/huobiDark.ae5fa915c99a81d0c42d94487b542d31.svg";
export { ForwardRef as ReactComponent };